module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-15-APRILE-small-db13abec049e92886768aabb48637ff7.jpg";